import { render, staticRenderFns } from "./TypeTextButtonPanel.vue?vue&type=template&id=07cbf38a&scoped=true"
import script from "./TypeTextButtonPanel.vue?vue&type=script&lang=js"
export * from "./TypeTextButtonPanel.vue?vue&type=script&lang=js"
import style0 from "./TypeTextButtonPanel.vue?vue&type=style&index=0&id=07cbf38a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cbf38a",
  null
  
)

export default component.exports